import { VIEWPORT_HEIGHT, VIEWPORT_WIDTH } from '../Constants';
import { scaleLayoutSvgX } from '../level/layoutViewBox';

/** Эталон ширины viewBox (v2 interact) для масштабирования хитбоксов спрайтов. */
export const RUNNER_REF_VIEWBOX_WIDTH = 4096;

/** Сдвиг точки спавна курьера влево: доля ширины design-viewport (1080px). */
export const RUNNER_SPAWN_SCREEN_X_OFFSET_RATIO = 0.1;

/** Переводит сдвиг спавна из px экрана в SVG user units уровня. */
export function runnerSpawnSvgXOffset(viewBoxHeight: number): number {
  if (viewBoxHeight <= 0) {
    return 0;
  }
  const displayScale = VIEWPORT_HEIGHT / viewBoxHeight;
  return (VIEWPORT_WIDTH * RUNNER_SPAWN_SCREEN_X_OFFSET_RATIO) / displayScale;
}

export const RUNNER_MARKER_SIZE_S = 68;

/** Static-препятствия: ~67% ширины маркера (ещё в 3 раза меньше, чем при scale 2). */
export const RUNNER_STATIC_OBSTACLE_SIZE_SCALE = 2 / 5;

/**
 * Serj / Yetti: визуал static-препятствия больше AABB.
 * Хитбокс остаётся на {@link RUNNER_STATIC_OBSTACLE_SIZE_SCALE}.
 */
export const RUNNER_SERJ_STATIC_OBSTACLE_VISUAL_SCALE = 1.5;
export const RUNNER_YETTI_STATIC_OBSTACLE_VISUAL_SCALE = 1.5;

export const RUNNER_PLAYER_SPRITE_WIDTH_S = 52;
export const RUNNER_PLAYER_SPRITE_HEIGHT_SVG = 54.625;

/** Хитбокс игрока относительно базового размера спрайта (−10%, затем ещё −15%). */
export const RUNNER_PLAYER_HITBOX_SCALE = 0.9 * 0.85;

/** Визуальный размер спрайта игрока относительно базового (+20%). */
export const RUNNER_PLAYER_VISUAL_SCALE = 1.2;

/** Отладочная отрисовка AABB-хитбоксов на уровне (игрок / препятствия / зефирки / бустеры). */
export const RUNNER_SHOW_HITBOX = false as const;

export const RUNNER_COLLECTIBLE_SPRITE_WIDTH_S = 20.25;
export const RUNNER_COLLECTIBLE_SPRITE_HEIGHT_SVG = 23;

export const RUNNER_SHIELD_BOOSTER_SPRITE_WIDTH_S = 23.75;
export const RUNNER_SHIELD_BOOSTER_SPRITE_HEIGHT_SVG = 20.25;

export const RUNNER_SPEED_BOOSTER_SPRITE_WIDTH_S = 39;
export const RUNNER_SPEED_BOOSTER_SPRITE_HEIGHT_SVG = 28.75;

export const RUNNER_LANE_MIN = 0;
export const RUNNER_LANE_MAX = 1;

/** Базовая скорость вдоль маршрута (м/с в координатах s), масштабируется по ширине уровня. */
export const RUNNER_FORWARD_SPEED_BASE_M_PER_SEC = 75;

export const RUNNER_MAX_DELTA_SECONDS = 0.05;

/** Длительность мигания, i-frames и замедления после удара без щита, сек. */
export const RUNNER_HIT_INVULN_SEC = 1.5;

/** Множитель скорости вперёд во время hit-invulnerability (−20%). */
export const RUNNER_HIT_SPEED_MULTIPLIER = 0.8;

/** Левый край зоны особого модификатора в SVG user units (layout art viewBox). */
export const RUNNER_MODIFIER_ZONE_SVG_X = scaleLayoutSvgX(5741.5723);

/** Ширина зоны особого модификатора в SVG user units (= м по `s`). */
export const RUNNER_MODIFIER_ZONE_SVG_WIDTH = scaleLayoutSvgX(2187.2659);
